import { render, staticRenderFns } from "./TicketsView.vue?vue&type=template&id=3301e90c&"
import script from "./TicketsView.vue?vue&type=script&lang=js&"
export * from "./TicketsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports